import { render } from "./SortablePage.vue?vue&type=template&id=79f52131&scoped=true"
import script from "./SortablePage.vue?vue&type=script&lang=js"
export * from "./SortablePage.vue?vue&type=script&lang=js"

import "./SortablePage.vue?vue&type=style&index=0&id=79f52131&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f52131"]])

export default __exports__